/**
 * Consistent names for ActionSheet / modal surfaces so SR doesn’t announce
 * empty “group” and close controls get a stable label (not stray “add …” from SVGs).
 */
export function getDialogAccessibilityLabel(
  sheetAccessibilityLabel?: string,
  headerTitle?: string
): string {
  const fromSheet = sheetAccessibilityLabel?.trim();
  if (fromSheet) {
    return fromSheet;
  }
  const fromHeader = headerTitle?.trim();
  if (fromHeader) {
    return fromHeader;
  }
  return 'Dialog';
}

export function getModalCloseAccessibilityLabel(
  sheetAccessibilityLabel?: string,
  headerTitle?: string
): string {
  return `Close ${getDialogAccessibilityLabel(sheetAccessibilityLabel, headerTitle)}`;
}
